(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gcie-split-slideshow"] && !Shopify.designMode) return;
  try {
    
  class GcieSplitSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.gcie-split-slideshow__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-gcie-dot]'));
      this.viewport = this.querySelector('.gcie-split-slideshow__viewport');
      this.playButton = this.querySelector('[data-gcie-play]');
      this.formes = Array.from(this.querySelectorAll('.gcie-split-slideshow__formes svg'));
      this.index = 0;
      this.timer = null;
      this.hovering = false;
      this.focused = false;
      this.editing = false;
      this.visible = true;
      this.userPaused = false;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reduceMotion = reduceMotion.matches;
      this.onMotionChange = (event) => {
        this.reduceMotion = event.matches;
        this.sync();
      };
      reduceMotion.addEventListener('change', this.onMotionChange);

      this.onVisibility = () => this.sync();
      document.addEventListener('visibilitychange', this.onVisibility);

      // Une seule diapositive : rien à faire défiler, mais les contours (SMIL) suivent quand même
      // le mouvement réduit et la visibilité de l'onglet.
      if (this.slides.length < 2) {
        this.syncFormes();
        return;
      }

      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = Math.max(3, Number(this.dataset.speed) || 6) * 1000;
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.style.setProperty('--gcie-intervalle', `${this.speed}ms`);

      this.querySelector('[data-gcie-prev]')?.addEventListener('click', () => this.go(this.index - 1, true, -1));
      this.querySelector('[data-gcie-next]')?.addEventListener('click', () => this.go(this.index + 1, true, 1));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = Number(dot.dataset.gcieDot);
          this.go(target, true, target >= this.index ? 1 : -1);
        });
      });

      // Glissé au doigt : au moins 40 px, plus horizontal que vertical ; gauche = suivante.
      if (this.viewport) {
        let x0 = null;
        let y0 = 0;
        this.viewport.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) { x0 = null; return; }
          x0 = event.touches[0].clientX;
          y0 = event.touches[0].clientY;
        }, { passive: true });
        this.viewport.addEventListener('touchend', (event) => {
          if (x0 === null) return;
          const dx = event.changedTouches[0].clientX - x0;
          const dy = event.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
          if (dx < 0) this.go(this.index + 1, true, 1);
          else this.go(this.index - 1, true, -1);
        }, { passive: true });
        this.viewport.addEventListener('touchcancel', () => { x0 = null; }, { passive: true });
      }

      // Lecture / pause (WCAG 2.2.2) : la pause de l'utilisateur l'emporte sur tout le reste.
      this.playButton?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.playButton.setAttribute('aria-pressed', String(!this.userPaused));
        this.playButton.setAttribute(
          'aria-label',
          this.userPaused ? 'Reprendre le défilement automatique' : 'Mettre en pause le défilement automatique'
        );
        this.sync();
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.index - 1, true, -1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.index + 1, true, 1);
        }
      });

      if (this.pauseOnHover) {
        this.addEventListener('pointerenter', () => {
          this.hovering = true;
          this.sync();
        });
        this.addEventListener('pointerleave', () => {
          this.hovering = false;
          this.sync();
        });
      }

      this.addEventListener('focusin', () => {
        this.focused = true;
        this.sync();
      });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) {
          this.focused = false;
          this.sync();
        }
      });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            this.visible = entries.some((entry) => entry.isIntersecting);
            this.sync();
          },
          { threshold: 0.25 }
        );
        this.observer.observe(this);
      }

      if (window.Shopify && window.Shopify.designMode) {
        this.onBlockSelect = (event) => {
          const slide = event.target?.closest?.('.gcie-split-slideshow__slide');
          if (!slide || !this.contains(slide)) return;
          this.editing = true;
          const target = this.slides.indexOf(slide);
          this.go(target, false, target >= this.index ? 1 : -1);
        };
        this.onBlockDeselect = (event) => {
          if (!this.contains(event.target)) return;
          this.editing = false;
          this.sync();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      this.sync();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.observer?.disconnect();
    }

    get shouldPlay() {
      return (
        this.autoplay &&
        !this.userPaused &&
        !this.reduceMotion &&
        !this.hovering &&
        !this.focused &&
        !this.editing &&
        this.visible &&
        document.visibilityState === 'visible'
      );
    }

    sync() {
      if (this.shouldPlay) {
        this.start();
      } else {
        this.stop();
      }
      if (this.viewport) {
        // Pas d'annonce vocale à chaque passage automatique ; annonce quand l'utilisateur navigue.
        this.viewport.setAttribute('aria-live', this.timer ? 'off' : 'polite');
      }
      this.syncFormes();
    }

    // Contours : morph SMIL figé en mouvement réduit (formes fixes) et quand l'onglet est caché.
    syncFormes() {
      const pause = this.reduceMotion || document.visibilityState !== 'visible';
      this.formes.forEach((svg) => {
        if (typeof svg.pauseAnimations !== 'function') return;
        if (pause) svg.pauseAnimations();
        else svg.unpauseAnimations();
      });
    }

    // Une minuterie par diapositive (et non un intervalle) : la barre de progression repart de zéro
    // à chaque diapositive, en retirant puis reposant data-gcie-lecture.
    start() {
      if (this.timer) return;
      delete this.dataset.gcieLecture;
      void this.offsetWidth;
      this.dataset.gcieLecture = 'true';
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.go(this.index + 1, false, 1);
        this.sync();
      }, this.speed);
    }

    stop() {
      delete this.dataset.gcieLecture;
      if (!this.timer) return;
      window.clearTimeout(this.timer);
      this.timer = null;
    }

    // `direction` : +1 la diapositive entre par la droite et la sortante part à gauche ; −1 l'inverse.
    go(target, byUser, direction = 1) {
      const count = this.slides.length;
      const next = ((target % count) + count) % count;
      if (next === this.index && this.slides[next].getAttribute('aria-current') === 'true') return;

      const entrant = this.slides[next];
      const sortant = this.slides[this.index];

      // 1. position de départ posée SANS transition, 2. reflow, 3. bascule → la transition part de là.
      entrant.dataset.gcieEtat = direction > 0 ? 'in-right' : 'in-left';
      void entrant.offsetWidth;
      delete entrant.dataset.gcieEtat;

      this.slides.forEach((slide, i) => {
        const active = i === next;
        if (active) {
          slide.setAttribute('aria-current', 'true');
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('inert');
        } else {
          slide.removeAttribute('aria-current');
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('inert', '');
        }
      });
      if (sortant !== entrant) sortant.dataset.gcieEtat = direction > 0 ? 'out-left' : 'out-right';

      this.dots.forEach((dot, i) => {
        if (i === next) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      this.index = next;
      const fg = this.slides[next].dataset.fg;
      if (fg) this.style.setProperty('--gcie-current-fg', fg);

      if (byUser) {
        // Une action de l'utilisateur relance le compteur à zéro.
        this.stop();
        this.sync();
      }
    }
  }

  if (!customElements.get('gcie-split-slideshow')) {
    customElements.define('gcie-split-slideshow', GcieSplitSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
